import { TutorialsLayout } from "~/components/TutorialsLayout";
import { MARGENS_LUCRO_VIDEOS } from "~/constants/tutorialVideos";

export function MargensLucroTutorialsTab() {
  return <TutorialsLayout videos={MARGENS_LUCRO_VIDEOS} />;
}
